// Copyright (c) 2022 Deere & Company

import actions from '../actions-list';

const updateSessionExpiredModalVisibility = (state, action) => action.isVisible;

export default (state = false, action) => {

    const actionTypes = {
        [actions.UPDATE_SESSION_EXPIRED_MODAL_VISIBILITY]: updateSessionExpiredModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/shared/reducers/session-expired-modal-visibility.js